import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagVendaResponse } from '../../responses/vendas/get-tag-venda.response';
import { CreateTagVendaResponse } from '../../responses/vendas/create-tag-venda.response';
import { TagVendaRequest } from '../../requests/vendas/tag-venda.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class TagVendaService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'TagVenda';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetTagVendaResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetTagVendaResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CreateTagVendaResponse> {
        const url = `${this.apiUrl}/idTagVenda/${id}`;
        return this.httpClient
            .get<CreateTagVendaResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: TagVendaRequest): Observable<CreateTagVendaResponse> {
        return this.httpClient
            .post<CreateTagVendaResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: TagVendaRequest): Observable<CreateTagVendaResponse> {
        const url = `${this.apiUrl}/idTagVenda/${id}`;
        return this.httpClient
            .put<CreateTagVendaResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idTagVenda/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
